import BaseSetup from '@/components/BaseSetup';
import BaseDocumentEntity from '@/entity/BaseDocumentEntity';
import { Reactive } from '@/utils/decorators';
import { ref } from 'vue';

export type SharedDocumentStickerEmits = {
	(e: 'select'): void
};
export type SharedDocumentStickerProps = {
	selected?: boolean
	opened?: boolean
	hideCheckbox?: boolean
	entity: BaseDocumentEntity<Armado.ArmadoDocument>
	title?: string
	actions?: DocumentItemAction[]
};

export default class SharedDocumentStickerSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _el = ref<OrionSticker>();
	@Reactive private readonly state = {
		tagSelectOpen: false,
		touchTimer: undefined as Undef<NodeJS.Timeout>,
		isScolling: false,
	};

	get tagSelectOpen () { return this.state.tagSelectOpen }
	set tagSelectOpen (val) { this.state.tagSelectOpen = val }

	constructor (
		private props: SharedDocumentStickerProps,
		private emits: SharedDocumentStickerEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();
		if (this.props.opened) {
			document.getElementsByClassName('is-opened')[0].scrollIntoView({ block: 'center' });
		}
	}

	handleTouchStart () {
		if (this.state.touchTimer === undefined) {
			this.state.touchTimer = setTimeout(() => {
				if (!this.state.isScolling) {
					this.emits('select');
					this.handleTouchEnd();
					if (this.isTouch && typeof window.navigator.vibrate !== 'undefined') {
						navigator.vibrate(200);
					}
				}
			}, 400);
		}
	}

	handleTouchEnd () {
		clearTimeout(this.state.touchTimer);
		this.state.touchTimer = undefined;
		this.state.isScolling = false;
	}

	handleScroll () {
		this.state.isScolling = true;
	}

}
